import { IPaginationInfo } from 'types/pagination'
import {
  ICreateDocumentSubmissionInput,
  IDocumentSubmission,
} from './document-submission'
import { IProcurementSubmission } from './procurement-submission'
import { ITechnicalSubmission } from './technical-submission'
import { ESubmissionEvaluationStatus } from './submissions-evaluation'

export enum SubmissionStatus {
  CREATED = 'CREATED',
  UNDER_EVALUATION = 'UNDER_EVALUATION',
  DECLINED = 'DECLINED',
  ACCEPTED = 'ACCEPTED',
  SUBMITTED = 'SUBMITTED',
}

export type ISubmission = {
  id: string
  lotId: string
  description: string
  submittedAt: number | null;
  status: SubmissionStatus
  canSubmit: boolean;
  tenderOrganizationId: string
  submitterOrganizationId: string
  documentSubmissions: IDocumentSubmission[]
  procurementSubmission: IProcurementSubmission
  technicalSubmission: ITechnicalSubmission
}

export type ISubmissionOverview = {
  id: string
  lotId: string
  description: string
  status: SubmissionStatus
  submissionEvaluationId: string
  evaluationStatus: ESubmissionEvaluationStatus
  tenderOrganizationId: string
  submitterOrganizationId: string
  submitterOrganizationName: string
  submittedAt: string
}

export type ISubmissionOverviews = {
  info: IPaginationInfo
  items: ISubmissionOverview[]
}

export type ICreateSubmissionInput = {
  id: string
  lotId: string
  description?: string
  status: SubmissionStatus
  technicalSubmission: Partial<IProcurementSubmission> | null
  procurementSubmission: Partial<ITechnicalSubmission> | null
  documentSubmissions: ICreateDocumentSubmissionInput[] | null
}

export type TSubmitter = {
  organizationId: string
  organizationName: string
}

export type TSubmitters = {
  info: IPaginationInfo
  items: TSubmitter[]
}
